import type { NuxtLinkProps } from 'nuxt/app'

interface ToastItem {
  id?: Number | String
  message: String
  type?: 'temp' | 'error'
  impact?: 'progress' | 'success' | 'error' | 'default',
  icon?: String
  secondaryAction? : {
    to: NuxtLinkProps,
    text: String
  }
}

export const useToast = () => {
  const items:Ref<ToastItem[]> = useState(() => ref([]))

  const showToast = (payload: ToastItem) => {
    const exists = items.value.find((item: ToastItem) => {
      return item.id === payload.id
    })
    if (payload.id && exists) { return }
    const id = payload.id || Date.now()
    const type = payload.type || 'temp'
    items.value.push({
      id,
      message: payload.message,
      type,
      impact: payload.impact,
      icon: payload.icon,
      secondaryAction: payload.secondaryAction
    })

    if (type === 'temp' || type === 'error') {
      setTimeout(() => {
        hideToast(id)
      }, 5000)
    }
  }

  const hideToast = (id: Number) => {
    items.value.forEach((item: ToastItem) => {
      if (id === item.id) {
        items.value.splice(items.value.indexOf(item), 1)
      }
    })
  }

  const hideAll = () => {
    items.value = []
  }

  return { showToast, hideToast, hideAll, items }
}
